import { render, staticRenderFns } from "./AddEditLeaves.vue?vue&type=template&id=a5c402d8&scoped=true"
import script from "./AddEditLeaves.vue?vue&type=script&lang=js"
export * from "./AddEditLeaves.vue?vue&type=script&lang=js"
import style0 from "./AddEditLeaves.vue?vue&type=style&index=0&id=a5c402d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c402d8",
  null
  
)

export default component.exports